import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import * as flyout from "./flyout";
import * as isViewingSoftCreditRatingForm from "./isViewingSoftCreditRatingForm";
import * as openGPC from "./openGPC";
import * as signIn from "./signIn";
import * as subModal from "./subModal";

export const setGarageCreated = actionCreator("onlineShopper/set/garageCreated");

export { flyout, isViewingSoftCreditRatingForm, openGPC, signIn, subModal };
